import React from 'react';
import { connect } from 'react-redux';
import { Layout, Footer, PageHeader, RecipeList, LottieLoadingView } from '../components'

const recipes = (props) => {
    return (
        <Layout>
            <PageHeader
                fontSize={14}
                fontFamily={'AmanticBold'}
                background={'#E6032B'}
                color={'white'}
                height={5}
                headercenter={'DELICIOUS RECIPES'}
                subheader={'Lorem ipsum dolor sit amet, nostrud exercitation ullamco.'} />
            {props.loading ? <LottieLoadingView /> : <RecipeList />}
            <Footer />
        </Layout>
    )
}

export default connect(state => ({ loading: state.getRecipesLoading }))(recipes);